var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurbineSapling = function SvgTurbineSapling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 106 170"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBED",
    d: "M60.5 170c21.815 0 39.5-2.239 39.5-5s-17.685-5-39.5-5-39.5 2.239-39.5 5 17.685 5 39.5 5",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD7DC",
    d: "m54.137 163.044-6-114.23h-3.14l-2.88 114.23s3.54 1.832 12.02 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M46.945 54.192s39.632 29.93 45.423 28.86c5.79-1.07-30.782-29.328-30.782-29.328s-10.947-1.79-14.64.468"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m83.165 71.069-4.192 4.938a92 92 0 0 0 8.55 5.071l2.46-3.26c-1.713-1.926-4.12-4.27-6.818-6.75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M44.892 55.053S2.106 80.491.928 86.183C-.25 91.872 39.56 68.758 39.56 68.758s6.008-9.408 5.332-13.706"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m14.917 82.053-2.877-5.98a99 99 0 0 0-8.134 6.38l2.02 3.63c2.476-.955 5.6-2.388 8.99-4.03"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M46.555 54.052S51.228 4.717 47.51.3s-8.574 41.408-8.574 41.408 3.938 10.338 7.618 12.344"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m42.95 13.884 5.973 1.13c.084-3.174.002-6.35-.245-9.515l-3.784-.494a131 131 0 0 0-1.945 8.88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M48.107 48.05h-2.831a3.9 3.9 0 0 0-1.515.245c-.484.182-.928.46-1.307.818a4 4 0 0 0-.9 1.268 4.1 4.1 0 0 0-.356 1.522v2.062l-.264 9.096 10.704-.983.302-7.708v-2.062a4.1 4.1 0 0 0-.234-1.58 4.1 4.1 0 0 0-.812-1.366 4 4 0 0 0-1.264-.942 3.9 3.9 0 0 0-1.523-.37"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.952 58.056a3.003 3.003 0 1 0 0-6.005 3.003 3.003 0 0 0 0 6.005"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#28C07F",
    d: "M105.002 87.917s0 20.586-6.046 27.448-18.134 11.441-22.166 8.004-7.05-12.583-2.014-19.445c5.037-6.862 14.106-9.149 20.152-10.295 3.797-.813 7.296-2.797 10.074-5.712M28 104.39s11.928-6.106 20.603-5.09c8.674 1.015 15.181 5.09 17.348 12.212 2.168 7.121-2.456 11.305-7.588 13.231-5.421 2.036-11.928 0-16.267-8.141C37.756 108.46 28 104.39 28 104.39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F9B7B",
    d: "M70.92 162.956s-3.012 1.49-7.737 0c0 0 2.213-15.432 2.213-19.846.6-4.07.22-8.215-1.107-12.126-2.208-5.515-12.154-14.335-14.363-16.54s-6.63-5.511-4.422-5.511 7.737 2.201 13.244 7.716a157 157 0 0 1 9.946 11.029s5.524-11.029 8.831-14.331 12.155-13.23 15.47-11.029-5.524 6.615-7.737 8.82-12.155 16.536-13.244 20.946-1.094 30.872-1.094 30.872"
  })));
};
export default SvgTurbineSapling;